import BigNumber from 'bignumber.js'
import { useCallback, useState } from 'react'
import { fetchBalance } from '../lib/balance'

export const useTokenBalance = () => {
  const [balance, setBalance] = useState<BigNumber>()
  const [error, setError] = useState('')
  const [symbol, setSymbol] = useState('')

  const clearState = () => {
    setError('')
    setSymbol('')
    setBalance(new BigNumber(0))
  }

  const getBalance = useCallback(async (tokenAddress: string, accountAddress: string) => {
    clearState()
    
    try {
      const { symbol: tokenSymbol, balance } = await fetchBalance(tokenAddress, accountAddress)

      setSymbol(tokenSymbol)
      setBalance(balance)
    } catch (ex) {
      console.error(ex)

      setError('There was an unexpected error while fetching the account balance. Please try again later.')
      setBalance(new BigNumber(0))
    }
  }, [])

  return {
    balance,
    symbol,
    error,
    clearState,
    getBalance
  }
}
